import React, { FC, useEffect, useState } from 'react';
import styles from './New.module.scss';
import Button from 'components/shared/Button';
import SocialLinks from '../../SocialLinks';
import { ReactComponent as EmailIcon } from 'images/new-icons/Message.svg';
import { ReactComponent as ProfileIcon } from 'images/new-icons/Profile.svg';
import { SignUpSteps } from './SignUpNew';
import supabase from 'sdk/api';
import { useTranslation } from 'react-i18next';

type Props = {
  email: string;
  setEmail: (email: string) => void;
  name: string;
  setName: (name: string) => void;
  setStep: (step: SignUpSteps) => void;
};
const capitalize = (str: string) => 
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

const Email: FC<Props> = ({ email, setEmail, name, setName, setStep }): JSX.Element => {
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [isNameValid, setIsNameValid] = useState<boolean>(true);
  const [isEmailExists, setIsEmailExists] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation() as any;

  
  const [firstName, setFirstName] = useState("");
  const [secondName, setSecondName] = useState("");
  const [isFirstNameValid, setIsFirstNameValid] = useState(true);
  const [isSecondNameValid, setIsSecondNameValid] = useState(true);
 

  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

const validateFullName = (name: string) => { 
  const re = /^[a-zA-Z]{1,30}\s[a-zA-Z]{1,30}$/;
  return re.test(name.trim());
};

const validateName = (name: string) => /^[a-zA-Z]{1,30}$/.test(name.trim());

  const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    if (/^[a-zA-Z]*$/.test(newName) && newName.length <= 30) {
      setFirstName(capitalize(newName));
      setIsFirstNameValid(validateName(newName));
      setName(`${newName} ${secondName}`.trim());
    }
  };

  const handleSecondNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    if (/^[a-zA-Z]*$/.test(newName) && newName.length <= 30) {
      setSecondName(capitalize(newName));
      setIsSecondNameValid(validateName(newName));
      setName(`${firstName} ${newName}`.trim());
    }
  };



  // const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const newName = e.target.value;
  //   if (/^[a-zA-Z\s]*$/.test(newName) && newName.length <= 30) {
  //     setName(newName);
  //     setIsNameValid(validateName(newName));
  //   }
  // };

  const handleNext = async () => {
    setIsLoading(true);
    try {
      const isValidEmail = validateEmail(email);

      const { data: userData } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('email', email);

      if (userData?.length) {
        setIsEmailExists(true);
        return;
      }

      setIsEmailValid(isValidEmail);
      if (isValidEmail) {
        setStep(SignUpSteps.Phone);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsEmailValid(true);
    setIsEmailExists(false);
  }, [email]);

  return (
    <div className={styles.email}>
      <div className={styles.step_header}>{t('step_one_your_email')}</div>
      <div style={{ width: '100%' }}>
        <div className={styles.email_fields}>
          <div
            className={styles.email_fields_field}
            style={{
              border: isNameValid ? '1px solid #01010180' : '1px solid #FF3B30',
            }}
          >
            <ProfileIcon />

            <input
              type="text"
              placeholder={t('first_name')}
              value={firstName}
              onChange={handleFirstNameChange}
              required
            />
          </div>
          <div
            className={styles.email_fields_field}
            style={{
              border: isNameValid ? '1px solid #01010180' : '1px solid #FF3B30',
            }}
          >
            <ProfileIcon />

            <input
              type="text"
              placeholder={t('second_name')}
              value={secondName}
              onChange={handleSecondNameChange}
              required
            />
          </div>

          <div
            className={styles.email_fields_field}
            style={{
              border: !isEmailValid || isEmailExists ? '1px solid #FF3B30' : '1px solid #01010180',
            }}
          >
            <EmailIcon />
            <input
              type="text"
              placeholder={t('email_address')}
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
        </div>
        {!isNameValid && (
          <div className={styles.error}>Name should contain only English letters and spaces</div>
        )}
        {!isEmailValid && <div className={styles.error}>{t('correctness_of_email')}</div>}
        {isEmailExists && <div className={styles.error}>Email already exists</div>}
      </div>
      <Button
        wide
        darkGreen
        onClick={handleNext}
        loading={isLoading}
        disabled={!email || !name || !isNameValid}
      >
        {t('next')}
      </Button>
      <div>{t('or')}</div>
      <SocialLinks />
    </div>
  );
};

export default Email;
